const getFrontendUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5002';
  }

  // Production - use api.zanthyr.com
  return 'https://api.zanthyr.com';
};

const getApiUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5002';
  }

  // Production - use api.zanthyr.com
  return 'https://api.zanthyr.com';
};

export const config = {
  frontendUrl: getFrontendUrl(),
  apiUrl: getApiUrl(),
  withCredentials: true,
  mapboxToken:
    'pk.eyJ1IjoiemFudGh5ciIsImEiOiJjbWQ0dm8zaTAwNWU3MmtyOW1kOXp2NWl1In0.iMaLcdtZHt_L3K15DtB6UA', // Replace with actual Mapbox token
};
